import { jsxs, jsx } from "react/jsx-runtime";
import { useColors } from "@inbody/core";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
function MenuSectionHeader({ label, iconNode }) {
  const { gray } = useColors();
  return /* @__PURE__ */ jsxs(
    Box,
    {
      sx: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        pl: "38px",
        pr: "20px",
        pt: "14px",
        pb: "8px",
        color: gray[500]
      },
      children: [
        iconNode && /* @__PURE__ */ jsx(
          Box,
          {
            sx: {
              display: "flex",
              flex: "0 0 14px",
              "& svg": { fontSize: "14px" }
            },
            children: iconNode
          }
        ),
        /* @__PURE__ */ jsx(
          Typography,
          {
            variant: "caption",
            sx: {
              fontSize: "11px",
              fontWeight: 600,
              lineHeight: 1.2,
              letterSpacing: "0.02em",
              color: "inherit"
            },
            children: label
          }
        )
      ]
    }
  );
}
export {
  MenuSectionHeader
};
